import { showErrorToast } from '@amigoapp/doca-react';
import { useCallback, useEffect, useRef, useState } from 'react';

const usePreviewDevices = (kind, track, errorText) => {
	const [devices, setDevices] = useState([]);
	const [activeDeviceId, setActiveDeviceId] = useState('');
	const [isSwitching, setIsSwitching] = useState(false);

	const switchingRef = useRef(false);

	useEffect(() => {
		let cancelled = false;

		const refresh = () => navigator.mediaDevices?.enumerateDevices()
			.then(found => !cancelled && setDevices(found.filter(device => device.kind === kind)))
			.catch(() => {});

		refresh();

		navigator.mediaDevices?.addEventListener('devicechange', refresh);

		return () => {
			cancelled = true;
			navigator.mediaDevices?.removeEventListener('devicechange', refresh);
		};
	}, [kind, track]);

	useEffect(() => {
		if (!track) {
			return;
		}

		setActiveDeviceId(track.mediaStreamTrack.getSettings().deviceId || '');
	}, [track]);

	const selectDevice = useCallback(async deviceId => {
		if (!track || switchingRef.current || deviceId === activeDeviceId) {
			return;
		}

		switchingRef.current = true;

		setActiveDeviceId(deviceId);
		setIsSwitching(true);

		try {
			await track.setDeviceId(deviceId);
		} catch (error) {
			showErrorToast(errorText);
		}

		setActiveDeviceId(track.mediaStreamTrack.getSettings().deviceId || deviceId);
		setIsSwitching(false);
		switchingRef.current = false;
	}, [track, activeDeviceId, errorText]);

	return { devices, activeDeviceId, isSwitching, selectDevice };
};

export default usePreviewDevices;
